import { MapPin, Mail, Phone, Linkedin, Github, ExternalLink, ChevronDown } from "lucide-react";
import { useEffect, useState } from "react";

const HeroSection = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    return (
        <section className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 flex items-center justify-center relative overflow-hidden">
            <div className="absolute inset-0">
                <div className="absolute top-20 left-20 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
                <div className="absolute top-40 right-20 w-96 h-96 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse delay-1000"></div>
                <div className="absolute -bottom-8 left-40 w-80 h-80 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse delay-2000"></div>
            </div>

            <div className={`text-center text-white z-10 px-6 pt-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                <div className="mb-8">
                    <div className="w-32 h-32 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full mx-auto mb-6 flex items-center justify-center text-4xl font-bold shadow-2xl">
                        KS
                    </div>
                </div>

                <h1 className="text-5xl md:text-7xl font-bold mb-4">
                    Kehinde Salaudeen
                </h1>

                <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-purple-500 mx-auto mb-6"></div>

                <p className="text-xl md:text-2xl text-gray-300 mb-4">
                    Senior Frontend Software Developer
                </p>

                <p className="text-lg text-gray-400 mb-8 max-w-screen-lg mx-auto">
                    6 years building high-performance web & mobile products with React, React Native, Vue.js, TypeScript, and Node.js
                </p>

                <div className="flex flex-wrap items-center justify-center gap-2 mb-10">
                    {["React", "React Native", "Vue", "TypeScript", "Node.js", "Firebase", "GraphQL"].map((item) => (
                        <span key={item} className="rounded-full border border-white/15 bg-white/10 px-4 py-2 text-sm text-white/90 backdrop-blur">
                            {item}
                        </span>
                    ))}
                </div>

                <div className="flex flex-wrap justify-center gap-4 mb-12">
                    <div className="flex items-center space-x-2 text-gray-300">
                        <MapPin className="w-5 h-5" />
                        <span>Lagos, Nigeria</span>
                    </div>
                    <div className="flex items-center space-x-2 text-gray-300">
                        <Mail className="w-5 h-5" />
                        <a href="mailto:kehindesalaudeen222@gmail.com" className="hover:text-white transition-colors">kehindesalaudeen222@gmail.com</a>
                    </div>
                    <div className="flex items-center space-x-2 text-gray-300">
                        <Phone className="w-5 h-5" />
                        <a href="tel:+2348085503290" className="hover:text-white transition-colors">+234 808 550 3290</a>
                    </div>
                </div>

                <div className="flex justify-center space-x-6 mb-8">
                    <a aria-label="LinkedIn" href="https://linkedin.com/in/kehnydev" target="_blank" rel="noopener noreferrer" className="p-3 bg-white/10 border border-white/10 rounded-full hover:bg-white/15 transition-colors">
                        <Linkedin className="w-6 h-6" />
                    </a>
                    <a aria-label="GitHub" href="https://github.com/kenicodex" target="_blank" rel="noopener noreferrer" className="p-3 bg-white/10 border border-white/10 rounded-full hover:bg-white/15 transition-colors">
                        <Github className="w-6 h-6" />
                    </a>
                    <a aria-label="Portfolio" href="https://khenny-portfolio.netlify.app" target="_blank" rel="noopener noreferrer" className="p-3 bg-white/10 border border-white/10 rounded-full hover:bg-white/15 transition-colors">
                        <ExternalLink className="w-6 h-6" />
                    </a>
                </div>

                <div className="flex justify-center gap-6">
                    <a
                        href="/CVs/kehinde-cv.pdf"
                        download
                        className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full font-semibold shadow-lg hover:scale-105 transition-transform"
                    >
                        Download CV
                    </a>
                    <a
                        href="#contact"
                        className="px-6 py-3 bg-gradient-to-r from-pink-500 to-red-500 rounded-full font-semibold shadow-lg hover:scale-105 transition-transform"
                    >
                        Get in Touch
                    </a>
                </div>

                <div className="mt-12 animate-bounce">
                    <ChevronDown
                        className="w-8 h-8 mx-auto cursor-pointer"
                        onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
                    />
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
